import { CommApiInstance } from "Utils/CommApiInstance";




const AthnQrLoginCmplApi = async (
) => {
    return await CommApiInstance.post("athn/qr/login/cmpl",{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default AthnQrLoginCmplApi;